module.exports = __webpack_public_path__ + "img/khipu.ab708b8.png";